/**
 * @see src/CamBundle/Message/Websocket/Schedule/ScheduleStatus.php
 */

import * as t from 'io-ts';
import { Type } from './Type';

export const ScheduleErrorC = t.type({
    type: t.literal(Type.ERROR),
    id: t.number,
    name: t.string,
    createdBy: t.number,
});

export type ScheduleError = t.TypeOf<typeof ScheduleErrorC>;
